import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryProductLine (params) {
  return request({
    ...APIS['@productLine/Query_ProductLine'],
    params
  })
}

export function addProductLine (data) {
  return request({
    ...APIS['@productLine/Add_ProductLine'],
    data
  })
}

export function updateProductLine (data) {
  return request({
    ...APIS['@productLine/Update_ProductLine'],
    data
  })
}

export function deleteProductLine (params) {
  return request({
    ...APIS['@productLine/Delete_ProductLine'],
    params
  })
}

export function queryProductTypes (params) {
  return request({
    ...APIS['@productLine/Query_ProductTypes'],
    params
  })
}
